<div class="receipts-layout">
  <div class="receipts-layout__validation">
    <ui-form-section title="Comprobantes">
      <ui-tag
        actions
        [label]="importesValidated() ? 'Validado' : 'Faltante'"
        [color]="importesValidated() ? 'success' : 'warning'"
        appearance="outline"
      />
      <div class="importe-validation">
        <div class="importe-validation__row">
          <span class="importe-validation__label">Subtotal partidas</span>
          <span class="importe-validation__value">{{ formatMoney(expectedSubtotal()) }}</span>
        </div>
        <div class="importe-validation__row">
          <span class="importe-validation__label">Subtotal comprobantes</span>
          <span class="importe-validation__value">{{ formatMoney(receiptsSubtotal()) }}</span>
        </div>
        <div class="importe-validation__row importe-validation__row--total">
          <span class="importe-validation__label">Diferencia</span>
          <span class="importe-validation__value">{{ formatMoney(differenceAmount()) }}</span>
        </div>
      </div>
    </ui-form-section>

    @if (requiresDelivery()) {
      <ui-form-section title="Saldo por facturar" data-testid="delivery-balance">
        <ui-tag
          actions
          [label]="deliveryInvoiced() ? 'Facturado' : 'Por facturar'"
          [color]="deliveryInvoiced() ? 'success' : 'warning'"
          appearance="outline"
        />
        <div class="importe-validation">
          <div class="importe-validation__row">
            <span class="importe-validation__label">Entregado</span>
            <span class="importe-validation__value">{{ formatMoney(deliveredSubtotal()) }}</span>
          </div>
          <div class="importe-validation__row">
            <span class="importe-validation__label">Facturado</span>
            <span class="importe-validation__value">{{ formatMoney(receiptsSubtotal()) }}</span>
          </div>
          <div class="importe-validation__row importe-validation__row--total">
            <span class="importe-validation__label">Por facturar</span>
            <span class="importe-validation__value">{{ formatMoney(balanceAmount()) }}</span>
          </div>
        </div>
      </ui-form-section>
    }

    @if (hasCfdi()) {
      <ui-form-section title="Importes CFDI" data-testid="cfdi-amounts">
        <div class="importe-validation">
          <div class="importe-validation__row">
            <span class="importe-validation__label">Subtotal</span>
            <span class="importe-validation__value">{{ formatMoney(cfdiSubtotal()) }}</span>
          </div>
          <div class="importe-validation__row">
            <span class="importe-validation__label">IVA</span>
            <span class="importe-validation__value">{{ formatMoney(receiptsIva()) }}</span>
          </div>
          <div class="importe-validation__row">
            <span class="importe-validation__label">Retención ISR</span>
            <span class="importe-validation__value">{{ formatMoney(receiptsRetencionIsr()) }}</span>
          </div>
          <div class="importe-validation__row">
            <span class="importe-validation__label">Retención IVA</span>
            <span class="importe-validation__value">{{ formatMoney(receiptsRetencionIva()) }}</span>
          </div>
          <div class="importe-validation__row importe-validation__row--total">
            <span class="importe-validation__label">Importe</span>
            <span class="importe-validation__value">{{ formatMoney(receiptsAmount()) }}</span>
          </div>
        </div>
      </ui-form-section>
    }
  </div>

  <div class="receipts-layout__table" aria-label="Comprobantes">
    <ui-data-table
      [columns]="columns()"
      [rows]="displayedRows()"
      [total]="displayedRows().length"
      [loading]="loading()"
      [showExcel]="true"
      [showStatusFilter]="true"
      [statusFilters]="visibleFilterGroups()"
      [segmentedFilters]="isBothMode() ? segmentedFilters() : []"
      [showPageSize]="true"
      [showNewButton]="canAddReceipt() && !readOnly()"
      [showColumnFilters]="true"
      [showActionsColumn]="true"
      [actionItems]="actionItems"
      [showTotals]="true"
      [columnsToTotal]="['subtotal', 'descuento', 'retencionIsr', 'retencionIva', 'iva', 'neto']"
      [verticalScroll]="true"
      [verticalScrollFill]="true"
      columnSizing="fixed"
      rowKey="id"
      (statusFilterChange)="onStatusFilter($event)"
      (columnFiltersChange)="onColumnFilters($event)"
      (segmentedFiltersChange)="onSegmentedFilter($event)"
      (sortChange)="onSort($event)"
      (exportExcel)="exportExcel.emit()"
      (newClick)="onNew()"
      (actionClick)="onAction($event)"
    />
  </div>
</div>

<ui-drawer
  [open]="drawerOpen()"
  (openChange)="drawerOpen.set($event)"
  [title]="drawerTitle()"
  cancelLabel="Cerrar"
  saveLabel="Guardar"
  panelWidth="1500px"
  [fill]="showFactura()"
  [closeOnSave]="false"
  (saved)="onDrawerSave()"
  (closed)="onDrawerClosed()"
>
  <div class="receipt-drawer__saldo" actions>
    <span class="receipt-drawer__saldo-label">
      {{ isBothMode()
        ? (requiresDelivery() ? 'Saldo por facturar' : 'Saldo subtotal')
        : 'Saldo subtotal partidas' }}
    </span>
    <div class="receipt-drawer__saldo-amount">
      <span class="receipt-drawer__saldo-value">{{ formatMoney(balanceAmount()) }}</span>
      <ui-tag
        [label]="balanceSettled() ? 'Saldado' : 'Pendiente'"
        [color]="balanceSettled() ? 'success' : 'warning'"
        appearance="outline"
      />
    </div>
  </div>
  <div class="receipt-drawer" [class.receipt-drawer--scroll]="showFactura()">
    @if (isBothMode()) {
      <div class="receipt-drawer__fields">
        <div class="receipt-drawer__tipo" data-testid="capture-type-selector">
          <span class="receipt-drawer__tipo-label" id="receipt-type-label">
            Tipo de comprobante
          </span>
          <div
            class="receipt-drawer__tipo-options"
            role="radiogroup"
            aria-labelledby="receipt-type-label"
          >
            <ui-radio
              name="receipt-type"
              value="Factura"
              label="Factura"
              [checked]="captureType() === 'Factura'"
              (checkedChange)="$event && selectTipo('Factura')"
            />
            <ui-radio
              name="receipt-type"
              value="General"
              label="Comprobante no fiscal"
              [checked]="captureType() === 'General'"
              (checkedChange)="$event && selectTipo('General')"
            />
          </div>
        </div>
      </div>
    }

    @if (showGeneral()) {
      <div class="receipt-drawer__form" data-testid="general-capture">
        @if (generalError()) {
          <p class="receipt-drawer__error" role="alert">{{ generalError() }}</p>
        }
        <div class="receipt-drawer__row receipt-drawer__row--capture">
          <div class="receipt-drawer__fecha">
            <ui-date-input
              label="Fecha"
              kind="date"
              [required]="true"
              [(value)]="fecha"
            />
          </div>
          <div class="receipt-drawer__importe">
            <ui-input
              label="Importe"
              kind="amount"
              placeholder="0.00"
              [required]="true"
              [(value)]="importe"
            />
          </div>
          <div class="receipt-drawer__documentos">
            <ui-file-upload
              label="Documentos"
              [multiple]="true"
              [accept]="pdfAccept"
              [maxSizeMB]="20"
              [block]="true"
              [(value)]="documentos"
            />
          </div>
          <div class="receipt-drawer__notas">
            <ui-textarea label="Notas" [block]="true" [(value)]="notas" />
          </div>
        </div>
      </div>
    }

    @if (showFactura()) {
      <ui-invoice-capture
        #invoiceCapture
        data-testid="cfdi-capture"
        [(files)]="files"
        [(notes)]="notas"
        [scrollable]="true"
        filesTitle="Archivos XML - PDF"
        [showNotes]="false"
        [manualValidation]="true"
        [maxValidatedSubtotal]="balanceAmount()"
        validationTitle="Validación XML - PDF"
        (criteriaMatch)="namesMatch.set($event)"
      >
        <ng-template #validationList>
          <table class="receipt-checks">
            @for (group of validationChecks; track group.title) {
              <tbody>
                <tr>
                  <th class="receipt-checks__heading" colspan="2">{{ group.title }}</th>
                </tr>
                @for (item of group.items; track item.text) {
                  <tr>
                    <td class="receipt-checks__mark">
                      <span
                        class="receipt-checks__icon"
                        [class.receipt-checks__icon--error]="item.key === 'names' && !namesMatch()"
                        aria-hidden="true"
                      ></span>
                    </td>
                    <td
                      class="receipt-checks__item"
                      [class.receipt-checks__item--error]="item.key === 'names' && !namesMatch()"
                    >{{ item.text }}</td>
                  </tr>
                }
              </tbody>
            }
          </table>
        </ng-template>
        <div validation-intro>
          <ng-container [ngTemplateOutlet]="validationList" />
        </div>
        <div validation-menu>
          <ng-container [ngTemplateOutlet]="validationList" />
        </div>
      </ui-invoice-capture>
    }
  </div>
</ui-drawer>
